<template>
    <div class="product-pagination" v-if="Pagination.prePage < Pagination.total">

        <nav aria-label="Page navigation example">
            <ul class="pagination">
                <li class="page-item">
                    <button class="page-link"  :class="Pagination.prevUrl===null?'disabled':''" @click.prevent="fatchData('',prevUrl)"  href="#"  aria-label="Previous" :disabled="Pagination.prevUrl===null">
                        <span aria-hidden="true">&laquo;</span>
                    </button>
                </li>


                <li class="page-item"  v-for="(link,index) in Pagination.paginationLink" v-if="link.label.length<2" :key="index" >
                    <a class="page-link " :class="Pagination.current_page==link.label?'active':''" href="#" @click.prevent="fatchData(link.label,'')">{{link.label}}</a>
                </li>

                <li class="page-item">
                    <button class="page-link"  :class="Pagination.nextUrl===null?'disabled':''"  @click.prevent="fatchData('',nextUrl)" href="#" aria-label="Next"  :disabled="Pagination.nextUrl===null">
                        <span aria-hidden="true">&raquo;</span>
                    </button>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export  default {
    props:['prePage','total','prevUrl','paginationLink','nextUrl','current_page'],

    methods:{
        fatchData(page,url){
            this.$emit('fatchData',page,url)

        }

    },

    computed:{
        ...mapGetters('Common',['Pagination'])

    },


}
</script>
